import {
  activityBaseApi,
  ActivityTags,
} from "activity/redux/api/activityBaseApi";
import { queryGenerator } from "activity/sub_modules/areatranfers/api/AreasTransfer.api";
import { IJSONResponse } from "components/afterLogin/dashboard/flightApis/AirlineDiscountMarkup/types";

export const activityPriorityApi = activityBaseApi.injectEndpoints({
  endpoints: (build) => ({
    //=============================== get all activities =====================================
    getActivitiesPriority: build.query<IJSONResponse, number>({
      query: (cityId) => `manageActivity/fetchActivities/${cityId}`,
      providesTags: [ActivityTags.getPriority],
    }),

    //=============================== update priority =====================================
    updatePriority: build.mutation<
      any,
      { priority: number; activityId: number }
    >({
      query: (body) => ({
        url: "manageActivity/updateActivityPriority",
        method: "POST",
        body,
      }),
      invalidatesTags: [ActivityTags.getPriority],
    }),

    //=============================== update priority =====================================
    updateArea: build.mutation<
      IJSONResponse,
      { areaId: number; activityId: number }
    >({
      query: (body) => ({
        url: "areas/mapAreaActivity",
        method: "POST",
        body,
      }),
      invalidatesTags: [ActivityTags.getPriority],
    }),

    //=============================== get all cities =====================================
    getCities: build.query<
      IJSONResponse<{ id: number; city: string }[]>,
      { filterBase: "areas" | "activities" | "areaTransfers" }
    >({
      query: (query) => `manageActivity/getAllCities?${queryGenerator(query)}`,
    }),
  }),
  overrideExisting: false,
});
